module.exports = __webpack_public_path__ + "img/logo.15b7253d.png";